module.exports = __webpack_public_path__ + "2db7b727286a7b983bd3820d493e2efa.jpg";